var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"calc(100vh - 282px)","overflow":"hidden"}},[_c('div',{ref:"sceneLine",staticClass:"shape"})])
}
var staticRenderFns = []

export { render, staticRenderFns }